const useEnv: boolean = typeof window === 'undefined' || window.location.hostname.includes('localhost');
const origin: string = useEnv ? null : window.location.origin;
const hostname: string = useEnv ? null : window.location.hostname;


export class config {
    public static websiteUrl: string = process.env.WEBSITE_URL;
    public static domain: string = useEnv ? process.env.APP_URL : origin;
    public static version: string = process.env.APP_VERSION;
    public static environment: string = process.env.APP_ENVIRONMENT;
    public static isDev: boolean = process.env.APP_ENVIRONMENT === "dev";
    public static isProd: boolean = config.environment == "prod";
    public static httpPanelUrl: string = useEnv ? process.env.SPRING_HTTP_PANEL : `${origin}/panel`;
    public static httpCommunityUrl: string = useEnv ? process.env.SPRING_HTTP_COMMUNITY : origin;
    public static httpWebsiteUrl: string = useEnv ? process.env.SPRING_HTTP_WEBSITE : `${origin}/website`;
    public static websocketPanelUrl: string = useEnv ? process.env.SPRING_WS_PANEL : `${origin.replace(/^http/, 'ws')}/websocket`;
    public static websocketCommunityUrl: string = useEnv ? process.env.SPRING_WS_COMMUNITY : `${origin.replace(/^http/, 'ws')}/community/websocket`;
    public static editorCollaborationUrl: string = useEnv ? process.env.EDITOR_COLLABORATION_WS : `${origin.replace(/^http/, 'ws')}/editor-collaboration`;
    public static rumEnabled: boolean = process.env.RUM_ENABLED === "true";

    public static product: string;

    public static tenorKey: string = "1HFPKNKBSCVT";
    public static tenorHost: string = "https://g.tenor.com/v1/";
    public static googleMapsKey: string = "AIzaSyDO9cPt7gBs7koM32VI5QEUaVXs8J6xDmU";
    public static googleMapsMapId: string = "475836b643ec66fdd1f07d4f";
    public static domainParent: string = useEnv ? "sedestral.com" : hostname.split('.').slice(-2).join('.');
    public static isWhiteLabel: boolean = !useEnv && !hostname.endsWith('sedestral.com');
    public static supportedBlogLanguages: string[] = ["de", "en", "es", "fr", "it", "nl", "pl"];

    public static prestaShopModuleVersion: string = "1.0.129";
    public static wordPressPluginVersion: string = "1.0.11";

    public static hotjarId: string = process.env.HOTJAR_ID;
    public static hotjarPanelId: string = process.env.HOTJAR_PANEL_ID;
    public static gtmId: string = process.env.GTM_ID;
    public static googleAdsId: string = process.env.GOOGLE_ADS_ID;
    public static googleAdsSignupLabel: string = process.env.GOOGLE_ADS_SIGNUP_LABEL;
    public static googleAdsPurchaseLabel: string = process.env.GOOGLE_ADS_PURCHASE_LABEL;
    public static googleAdsScheduleLabel: string = process.env.GOOGLE_ADS_SCHEDULE_LABEL;
    public static lucaWebsiteToken: string = process.env.LUCA_WEBSITE_TOKEN;

    static import(product: string) {
        this.product = product;
    }
}